import Avvir, { ResponseError } from "avvir";

import makeEventfulAction, { AvvirThunk } from "../make_eventful_action";
import floorTradeBuiltElementCountsLoaded, { FloorTradeBuiltElementCountsLoadedEvent } from "../../events/loaded/projects/floor_trade_built_element_counts_loaded";
import projectNotFound, { ProjectNotFoundEvent } from "../../events/notifications/failure_notifications/project_not_found";
import { FloorTradeBuiltElementCounts } from "../../services/reducers/domain/reduce_floor_trade_built_element_counts";

function loadFloorTradeBuiltElementCounts(projectId: string): AvvirThunk<Promise<FloorTradeBuiltElementCounts>, FloorTradeBuiltElementCountsLoadedEvent | ProjectNotFoundEvent> {
  return (dispatch, getState) => {
    const user = getState().user;

    return Avvir.api.projects.getProjectFloorTradeBuiltElementCounts({ projectId }, user)
      .then((builtElementCounts) => {
        dispatch(floorTradeBuiltElementCountsLoaded(projectId, builtElementCounts));
        return builtElementCounts;
      }).catch((error) => {
        if (error instanceof ResponseError && error.status === 404 && error.message.toLowerCase().includes("project does not exist")) {
          dispatch(projectNotFound());
        } else {
          throw error;
        }
      }) as Promise<FloorTradeBuiltElementCounts>;
  };
}

export default makeEventfulAction("loadFloorTradeBuiltElementCounts", loadFloorTradeBuiltElementCounts);
